import React from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  Divider,
  useTheme
} from "@mui/material";
import MKTypography from "../components/MKTypography";
import { PRIMARY_PINK } from "../constants";

function TermsOfServicePage() {
  const theme = useTheme();

  return (
    <Box sx={{ minHeight: "100vh", py: 4 }}>
      <Container maxWidth="md">
        <Paper sx={{ p: { xs: 3, md: 6 }, borderRadius: 2 }}>
          <MKTypography
            component="h1"
            variant="h3"
            fontWeight="bold"
            mb={3}
            sx={{ color: PRIMARY_PINK, textAlign: 'center' }}
          >
            Terms of Service
          </MKTypography>
          
          <MKTypography variant="body2" color="text.secondary" mb={4} sx={{ textAlign: 'center' }}>
            Last updated: {new Date().toLocaleDateString()}
          </MKTypography>

          <Divider sx={{ mb: 4 }} />

          <Box sx={{ mb: 4 }}>
            <MKTypography
              component="h2"
              variant="h5"
              fontWeight="bold"
              mb={2}
              sx={{ color: PRIMARY_PINK }}
            >
              Acceptance of Terms
            </MKTypography>
            <MKTypography variant="body1" mb={2}>
              By accessing and using the San Diego Gaming website and services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
            </MKTypography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <MKTypography
              component="h2"
              variant="h5"
              fontWeight="bold"
              mb={2}
              sx={{ color: PRIMARY_PINK }}
            >
              Use License
            </MKTypography>
            <MKTypography variant="body1" mb={2}>
              Permission is granted to temporarily download one copy of the materials on San Diego Gaming's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
            </MKTypography>
            <Box component="ul" sx={{ pl: 3 }}>
              <MKTypography component="li" variant="body1" mb={1}>
                Modify or copy the materials
              </MKTypography>
              <MKTypography component="li" variant="body1" mb={1}>
                Use the materials for any commercial purpose or for any public display
              </MKTypography>
              <MKTypography component="li" variant="body1" mb={1}>
                Attempt to reverse engineer any software contained on the website
              </MKTypography>
              <MKTypography component="li" variant="body1" mb={1}>
                Remove any copyright or other proprietary notations from the materials
              </MKTypography>
            </Box>
          </Box>

          <Box sx={{ mb: 4 }}>
            <MKTypography
              component="h2"
              variant="h5"
              fontWeight="bold"
              mb={2}
              sx={{ color: PRIMARY_PINK }}
            >
              User Conduct
            </MKTypography>
            <MKTypography variant="body1" mb={2}>
              You agree to use our services in a manner that is lawful and respectful. You agree not to:
            </MKTypography>
            <Box component="ul" sx={{ pl: 3 }}>
              <MKTypography component="li" variant="body1" mb={1}>
                Post or transmit any content that is harmful, threatening, abusive, or defamatory
              </MKTypography>
              <MKTypography component="li" variant="body1" mb={1}>
                Harass, intimidate, or bully other users
              </MKTypography>
              <MKTypography component="li" variant="body1" mb={1}>
                Post spam, advertisements, or other unsolicited content
              </MKTypography>
              <MKTypography component="li" variant="body1" mb={1}>
                Violate any applicable laws or regulations
              </MKTypography>
              <MKTypography component="li" variant="body1" mb={1}>
                Impersonate any person or entity
              </MKTypography>
            </Box>
          </Box>

          <Box sx={{ mb: 4 }}>
            <MKTypography
              component="h2"
              variant="h5"
              fontWeight="bold"
              mb={2}
              sx={{ color: PRIMARY_PINK }}
            >
              Account Responsibility
            </MKTypography>
            <MKTypography variant="body1" mb={2}>
              When you create an account with us, you are responsible for:
            </MKTypography>
            <Box component="ul" sx={{ pl: 3 }}>
              <MKTypography component="li" variant="body1" mb={1}>
                Maintaining the confidentiality of your account credentials
              </MKTypography>
              <MKTypography component="li" variant="body1" mb={1}>
                All activities that occur under your account
              </MKTypography>
              <MKTypography component="li" variant="body1" mb={1}>
                Providing accurate and up-to-date information
              </MKTypography>
              <MKTypography component="li" variant="body1" mb={1}>
                Notifying us immediately of any unauthorized use of your account
              </MKTypography>
            </Box>
          </Box>

          <Box sx={{ mb: 4 }}>
            <MKTypography
              component="h2"
              variant="h5"
              fontWeight="bold"
              mb={2}
              sx={{ color: PRIMARY_PINK }}
            >
              Content and Intellectual Property
            </MKTypography>
            <MKTypography variant="body1" mb={2}>
              You retain ownership of any content you post to our platform. By posting content, you grant us a non-exclusive, royalty-free license to use, display, and distribute your content in connection with our services.
            </MKTypography>
            <MKTypography variant="body1" mb={2}>
              All content on our website, including text, graphics, logos, and software, is the property of San Diego Gaming or its content suppliers and is protected by copyright and other intellectual property laws.
            </MKTypography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <MKTypography
              component="h2"
              variant="h5"
              fontWeight="bold"
              mb={2}
              sx={{ color: PRIMARY_PINK }}
            >
              Limitation of Liability
            </MKTypography>
            <MKTypography variant="body1" mb={2}>
              In no event shall San Diego Gaming or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on San Diego Gaming's website, even if San Diego Gaming or a San Diego Gaming authorized representative has been notified orally or in writing of the possibility of such damage.
            </MKTypography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <MKTypography
              component="h2"
              variant="h5"
              fontWeight="bold"
              mb={2}
              sx={{ color: PRIMARY_PINK }}
            >
              Disclaimer
            </MKTypography>
            <MKTypography variant="body1" mb={2}>
              The materials on San Diego Gaming's website are provided on an 'as is' basis. San Diego Gaming makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
            </MKTypography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <MKTypography
              component="h2"
              variant="h5"
              fontWeight="bold"
              mb={2}
              sx={{ color: PRIMARY_PINK }}
            >
              Privacy Policy
            </MKTypography>
            <MKTypography variant="body1" mb={2}>
              Your privacy is important to us. Please review our Privacy Policy, which also governs your use of our services, to understand our practices.
            </MKTypography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <MKTypography
              component="h2"
              variant="h5"
              fontWeight="bold"
              mb={2}
              sx={{ color: PRIMARY_PINK }}
            >
              Termination
            </MKTypography>
            <MKTypography variant="body1" mb={2}>
              We may terminate or suspend your account and access to our services immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
            </MKTypography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <MKTypography
              component="h2"
              variant="h5"
              fontWeight="bold"
              mb={2}
              sx={{ color: PRIMARY_PINK }}
            >
              Changes to Terms
            </MKTypography>
            <MKTypography variant="body1" mb={2}>
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days notice prior to any new terms taking effect.
            </MKTypography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <MKTypography
              component="h2"
              variant="h5"
              fontWeight="bold"
              mb={2}
              sx={{ color: PRIMARY_PINK }}
            >
              Contact Information
            </MKTypography>
            <MKTypography variant="body1" mb={2}>
              If you have any questions about these Terms of Service, please contact us at:
            </MKTypography>
                        <Box sx={{ pl: 2 }}>
              <MKTypography variant="body1" mb={1}>
                <strong>Email:</strong> legal@sandiegogaming.com
              </MKTypography>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}

export default TermsOfServicePage;
